import {ajax, event, isVisible, selectDoc} from "../utils/utils";

let props = {
    showModalCount: 0,
    body: null,
    popup: null
}

const checkOutSide = async (e) => {
    let modal = selectDoc('#notification-modal .modal');
    if (!modal.contains(e.target) && isVisible(modal)) {
        if (props.showModalCount > 0) {
            props.showModalCount = 0;
            props.body.removeChild(props.popup)
            document.removeEventListener('click', checkOutSide);
        } else {
            props.showModalCount++;
        }
    }
}

export const notify = async (title, message, cta = null, cta_url = null, confirm = false) => {
    try {
        if(!selectDoc('#notification-modal')) {
            /**
             * Add popup
             */
            props.popup =  document.createElement('div');
            props.popup.id = 'notification-modal'
            props.popup.className = `modal-container active`
            props.popup.setAttribute('role', 'dialog')
            props.popup.setAttribute('tabindex', '-1')
            props.popup.setAttribute('aria-hidden', 'false')
            props.popup.innerHTML = `<div class="modal">
                                        <div class="header">
                                            <p class="body body-left">${title}</p>
                                            <div class="cancel">
                                                <button id="cancel-notify">Cancel</button>
                                            </div>
                                        </div>
                                        <div class="content">
                                            <div class="h2 h2-center">${message}</div>
                                        </div>
                                        <div class="footer">
                                            <a href="${cta_url}" id="cta-notify" class="btn">${cta}</a>
                                        </div>
                                    </div>`
            props.body = selectDoc('#site-modals-container')
            props.body.appendChild(props.popup)

            /**
             * Add events
             */
            event(document, 'click', checkOutSide);
            let cancel = selectDoc('#cancel-notify');
            let ctaButton = selectDoc('#cta-notify');

            if(cancel && !confirm){
                event(cancel, 'click', function () {
                    document.removeEventListener('click', checkOutSide);
                    props.body.removeChild(props.popup)
                })
            }

            if(confirm && ctaButton && cancel) {
                return new Promise(resolve => {
                    event(ctaButton, 'click', function (e) {
                        e.preventDefault()
                        resolve(true)
                        document.removeEventListener('click', checkOutSide);
                        props.body.removeChild(props.popup)
                    })
                    event(cancel, 'click', function () {
                        resolve(false)
                        document.removeEventListener('click', checkOutSide);
                        props.body.removeChild(props.popup)
                    })
                });
            }
        }
    } catch (e) {
        console.log('Error creating notification.', e)
    }
}

